const { REACT_APP_MAPS_KEY } = process.env;
export const GENERAL_CONSTANTS = {
  URL_API_MAPS: `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${REACT_APP_MAPS_KEY}`,
};
